module.exports = __webpack_public_path__ + "static/media/recommendation.891e61dc.png";